import moment from 'moment';

export const transform = ({
                              id,
                              name,
                              timeframe,
                              order,
                              failkpi,
                              fornakpi,
                              kpimandatory,
                              kpiremark,
                              isexpired
                          }) => (
    {
        id: id,
        name: name,
        timeframe: timeframe,
        order: order,
        failkpi: failkpi,
        fornakpi: fornakpi,
        kpimandatory: kpimandatory,
        kpiremark: kpiremark,
        isexpired:isexpired
    }
);
